import { H3, Link, StatelessCol } from '@atlassian/amkt-common';
import {
  ANALYTICS_ACTION_CLICKED,
  ANALYTICS_SUBJECT_ID_DISCOVER_TILE,
  ANALYTICS_SUBJECT_TILE,
  EVENT_CONTAINER_HOME_SCREEN,
  TileClickedEvent,
} from '@atlassian/mpac-analytics';
import classNames from 'classnames';
import { Set } from 'immutable';
import React from 'react';

import * as webAnalytics from 'common/utils/analytics/webAnalytics';

import type { CategoryTileType } from '../../../records/CategoryTile';
import type { ScreenClass } from '@atlassian/mpac-types';

import styles from './CategoryTile.less';

const largeScreenClasses = Set(['sm', 'md', 'lg', 'xl']);

type CategoryTileProps = {
  categoryTile: CategoryTileType;
  href: string;
  onClick: (...args) => void;
  screenClass: ScreenClass;
};
const CategoryTile = (props: CategoryTileProps) => {
  const onClick = (event) => {
    props.onClick(event, {
      category: props.categoryTile?.key,
      href: props.href,
    });
    const tileType = largeScreenClasses.includes(props.screenClass) ? 'large' : 'small';

    webAnalytics.sendUIEvent({
      eventType: TileClickedEvent,
      event: ANALYTICS_ACTION_CLICKED,
      eventContainer: EVENT_CONTAINER_HOME_SCREEN,
      actionSubjectId: ANALYTICS_SUBJECT_ID_DISCOVER_TILE,
      eventComponent: ANALYTICS_SUBJECT_TILE,
      eventName: ANALYTICS_ACTION_CLICKED,
      label: props.categoryTile?.key || 'NONE',
      attributes: {
        tileType,
        source: EVENT_CONTAINER_HOME_SCREEN,
        objectType: ANALYTICS_SUBJECT_ID_DISCOVER_TILE,
        category: props.categoryTile?.key,
        sectionTitle: 'Discover new apps',
      },
    });
  };
  const isLarge = largeScreenClasses.includes(props.screenClass);
  return (
    <StatelessCol
      className={classNames({
        [styles.categoryTile]: true,
        [styles.large]: isLarge,
        [styles.small]: !isLarge,
      })}
      gutterWidth={26}
      screenClass={props.screenClass}
      xs={12}
      sm={6}
      md={4}
      lg={4}
      xl={4}
    >
      <div className={styles.categoryTileInner}>
        <Link className={styles.categoryTileLink} href={props.href} onClick={onClick}>
          <div
            className={styles.categoryImageContainer}
            style={{
              background: props.categoryTile.backgroundColor,
            }}
          >
            <div className={styles.categoryImageInner}>
              <div className={styles.categoryImageWrapper}>
                <img
                  className={styles.categoryImage}
                  src={props.categoryTile.image}
                  alt={`${props.categoryTile.name} category`}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className={styles.textSection}>
            <div className={styles.textSectionInner}>
              <H3 className={styles.categoryName}>{props.categoryTile.name}</H3>
            </div>
          </div>
        </Link>
      </div>
    </StatelessCol>
  );
};

export default CategoryTile;
